/*
 * @providesModule PlayableMatchesActionCreator
 */

import MinFlux from 'min-flux';
import FTUEController from 'FTUEController';
import ClientPropertyConstants from 'ClientPropertyConstants';

export default new MinFlux.ActionCreator({
  actionTypes: {
    FETCH_MATCH_LIST: null,
    SELECT_MATCH_LIST: null,
    SEARCH_FOR_EVENTS: null,
    HIGHLIGHT_MATCH: null,
  },

  selectMatchCategory(matchCategoryType) {
    this.dispatch(this.actionTypes.SELECT_MATCH_LIST, {
      matchCategoryType: matchCategoryType,
    });
  },

  fetchMatchList(showLoading) {
    this.dispatch(this.actionTypes.FETCH_MATCH_LIST, {
      showLoading: showLoading,
      isFTUE:
        !FTUEController.hasSeenMatchSelectTutorial() &&
        !ClientPropertyConstants.getFTUESkipMatchTutorial(),
    });
  },

  searchForEvents(searchTerm) {
    this.dispatch(this.actionTypes.SEARCH_FOR_EVENTS, {
      searchTerm: searchTerm,
    });
  },

  highlightMatch(event) {
    this.dispatch(this.actionTypes.HIGHLIGHT_MATCH, event);
  },
});
